import React, { useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Col, Divider, message, Modal, Row } from "antd";
import Button from "../Button";

interface IDeleteConfirmationModalProps {
  title: string;
  visibility: boolean;
  body: React.ReactNode;
  onCancel: () => void;
  onOk?: () => Promise<void>;
  updateData?: () => void;
  setVisibility: (param: any) => void;
  buttonLabel?: string;
  showToast?: boolean;
}

const DeleteConfirmationModal: React.FC<IDeleteConfirmationModalProps> = ({
  title,
  visibility,
  onCancel,
  onOk,
  body,
  updateData,
  setVisibility,
  buttonLabel,
  showToast = true
}) => {
  const [loading, setLoading] = useState(false);
  const handleOnOk = () => {
    setLoading(true);
    const finish = () => {
      setLoading(false);
      updateData?.();
      setVisibility(false);
      showToast && message.success("Deletado com sucesso");
    };
    if (onOk) {
      onOk()
        .then(() => finish())
        .catch((err) => {
          showToast && message.error("Algo deu errado");
          setLoading(false);
        });
    } else {
      finish();
    }
  };
  return (
    <Modal
      title={title}
      footer={null}
      destroyOnClose
      onCancel={onCancel}
      visible={visibility}
      maskClosable={false}
    >
      <p>{body}</p>
      <Divider />
      <Row gutter={16}>
        <Col span={12}>
          <Button
            size="large"
            disabled={loading}
            onClick={onCancel}
            className="full-width"
          >
            Cancelar
          </Button>
        </Col>
        <Col span={12}>
          <Button
            size="large"
            type="primary"
            disabled={loading}
            onClick={handleOnOk}
            className="full-width"
          >
            {loading && <LoadingOutlined />}
            {buttonLabel || "Deletar"}
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default DeleteConfirmationModal;
